import type { FC } from 'react';

interface JsonLdProps {
  data: Record<string, unknown>;
}

const JsonLd: FC<JsonLdProps> = ({ data }) => {
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(data, null, 2) }}
    />
  );
};

export default JsonLd;